import request from '../../service/request';

export const fetchViewSettingsService = ({ clientId, artworkId }) => {
    return request({
        url: `customers/${clientId}/artwork/${artworkId}`,
        method: 'get'
    })
        .then(response => response.data)
        .catch(({ data }) => ({ error: data }));
};

/**
 * Fetch (or trigger server-side generation of) the hosted GLB for the AR
 * "View in Your Room" model. Returns { url, frame } or null when the API has
 * no model for this artwork/frame. The GLB is served from a real CDN URL so
 * Android Scene Viewer and iOS Quick Look — which fetch the model over HTTP —
 * can load it (a browser blob URL only works for model-viewer's WebXR mode).
 */
export const fetchArModelService = ({ clientId, artworkId, frameType }) => {
    return request({
        url: 'wallpreview/ar-model',
        method: 'post',
        data: { clientId: Number(clientId), artworkId: Number(artworkId), frameType }
    })
        .then(response => {
            const arModel = response.data?.response?.data?.arModel;
            return arModel && arModel.url ? arModel : null;
        });
};
